<template>
  <footer>
    <div class="elegant-footer">
      <div class="footer-content text-center">
        <div class="footer-links mb-3">
          <span class="footer-text">Created by</span>
          <a href="https://minhhungtsbd.me" class="footer-link" :class="[isDarkMode ? 'link-light' : 'link-dark']"
             target="_blank" rel="noopener noreferrer">
            <i class="bi bi-person-circle me-1"></i>minhhungtsbd.me
          </a>
          <span class="footer-separator">•</span>
          <span class="footer-text">Powered by</span>
          <a href="https://cloudmini.net" class="footer-link" :class="[isDarkMode ? 'link-light' : 'link-dark']"
             target="_blank" rel="noopener noreferrer">
            <i class="bi bi-cloud me-1"></i>Cloudmini.net
          </a>
        </div>
      </div>
    </div>


    <div id="copyright" v-if="!configs.originalSite">
      <p class="text-center fs-6 fw-light" style="opacity: 0.5;">
        {{ t('page.copyRightName') }} <a :href="t('page.copyRightLink')" class="link-underline-light" target="_blank"
          :class="[isDarkMode ? 'link-light' : 'link-dark']">{{ t('page.copyRightLinkName') }}</a>
      </p>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '@/store';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const store = useMainStore();
const isDarkMode = computed(() => store.isDarkMode);
const configs = computed(() => store.configs);
</script>

<style scoped>
/* Elegant Footer Styles */
.elegant-footer {
  padding: 1.5rem 0;
  margin-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.footer-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.95rem;
}

.footer-text {
  color: #6c757d;
  font-weight: 400;
}

.footer-link {
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.footer-link:hover {
  transform: translateY(-1px);
  text-decoration: underline;
}

.footer-separator {
  color: #6c757d;
  margin: 0 0.5rem;
  font-weight: 300;
}

/* Dark mode support */
[data-bs-theme="dark"] .elegant-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Mobile responsiveness */
@media (max-width: 576px) {
  .footer-links {
    flex-direction: column;
    gap: 0.3rem;
  }
  
  .footer-separator {
    display: none;
  }
  
  .elegant-footer {
    padding: 1rem 0;
  }
}
</style>
